/**
 * @format
 */

export const PartnerSurveySubmissionMixin = {
    methods: {
        mapResponseItem(item) {
            const noneOptionSelected =
                item.content.hasNoneOption && item.content.noneOption.isChecked;
            const hasOtherOptionSelected =
                item.content.hasOtherOption && item.content.otherOption.isChecked;
            if (noneOptionSelected) {
                return {
                    frontendId: item.id,
                    none: true,
                };
            }

            if (item.type === 'radio-button') {
                const radioAnswer = hasOtherOptionSelected
                    ? {
                          details: [
                              {
                                  value: item.content.value.value || '',
                                  other: true,
                                  index: item.content.value.id,
                              },
                          ],
                          value: null,
                      }
                    : { value: item.content.value.label, index: item.content.value.id };
                return { frontendId: item.id, ...radioAnswer, none: false };
            }
            if (item.type === 'checkbox') {
                const checkboxAnswers = [];
                checkboxAnswers.push(...this.mapCheckboxItem(item.content.options, false));
                if (hasOtherOptionSelected) {
                    checkboxAnswers.push(...this.mapCheckboxItem([item.content.otherOption], true));
                }
                return {
                    frontendId: item.id,
                    details: checkboxAnswers,
                    none: false,
                };
            }

            if (item.type === 'file-upload' && item.content.value.length) {
                const fileAnswers = item.content.value.map((item) => ({
                    index: item.id,
                    mimeType: item.type,
                    fileName: item.name,
                    fileURL: item.url,
                    fileSize: String(item.size),
                }));

                return {
                    frontendId: item.id,
                    details: fileAnswers,
                };
            }

            if (item.type === 'dropdown' && item.content.value) {
                const isMultiselect = item.content.isMultiselect;
                if (isMultiselect) {
                    return {
                        frontendId: item.id,
                        details: this.mapMultiselectItem(item.content.value),
                        index: item.content.value.id,
                    };
                }
                return {
                    frontendId: item.id,
                    value: item.content.value.label,
                    index: item.content.value.id,
                };
            }

            if (item.type === 'currency') {
                return {
                    frontendId: item.id,
                    value: String(item.content.value),
                    currency: item.content.currency,
                };
            }

            return {
                frontendId: item.id,
                value: String(item.content.value),
            };
        },

        mapCheckboxItem(array, isOther) {
            return array
                .filter((item) => item.isChecked)
                .map((item) => {
                    return {
                        index: item.id,
                        ...(isOther
                            ? { value: item.value || '', other: true }
                            : { value: item.label }),
                    };
                });
        },

        mapMultiselectItem(array) {
            return array
                .map((item) => {
                    return {
                        index: item.id,
                        ...{ value: item.label },
                    };
                });
        },

        getElementValueFormat(htmlElement, savedAnswer) {
            if (htmlElement.type === 'dropdown' && !htmlElement.content.isMultiselect) {
                htmlElement.content.value = {
                    id: savedAnswer.Index,
                    label: savedAnswer.Value,
                    isChecked: true,
                };
                return;
            } else if (htmlElement.type === 'file-upload') {
                const Files = savedAnswer.Details.map((item) => ({
                    id: item.Index,
                    name: item.FileName,
                    size: Number(item.FileSize),
                    type: item.MIMEType,
                    url: item.FileURL,
                    downloadUrl: item.FileURL,
                }));
                htmlElement.content.value = Files;
                return;
            } else if (htmlElement.type === 'checkbox' || htmlElement.type === 'radio-button' || (htmlElement.type === 'dropdown' && htmlElement.content.isMultiselect)) {
                const arrayValue = [];
                if (savedAnswer.None) {
                    htmlElement.content.noneOption.isChecked = true;
                    if (htmlElement.type === 'checkbox') {
                        htmlElement.content.value = [htmlElement.content.noneOption];
                    } else {
                        htmlElement.content.value = htmlElement.content.noneOption;
                    }
                    return;
                }
                savedAnswer.Details.forEach((item) => {
                    if (item.Other) {
                        htmlElement.content.otherOption.isChecked = true;
                        htmlElement.content.otherOption.value = item.Value;
                        arrayValue.push(htmlElement.content.otherOption);
                    }
                    const option = htmlElement.content.options.find(
                        (htmlItem) => item.Index === htmlItem.id,
                    );
                    if (option) {
                        option.isChecked = true;
                        arrayValue.push(option);
                    }
                });
                if (!savedAnswer.Details.length && htmlElement.type === 'radio-button') {
                    const option = htmlElement.content.options.find(
                        (htmlItem) => savedAnswer.Index === htmlItem.id,
                    );
                    if (option) {
                        option.isChecked = true;
                        arrayValue.push(option);
                    }
                }

                const isArrayValue = htmlElement.type === 'checkbox' || (htmlElement.type === 'dropdown' && htmlElement.content.isMultiselect);

                htmlElement.content.value =
                    isArrayValue ? arrayValue : arrayValue[0];
                return;
            } else if (htmlElement.type === 'currency') {
                htmlElement.content.currency = savedAnswer.Currency;
            }

            htmlElement.content.value = savedAnswer.Value;
        },
    },
};
